import React, { Component } from "react";
import { Grid, Chip, Button } from '@material-ui/core';
import { KeyboardArrowDown } from '@material-ui/icons';
import StatusCard from "../status-card/status-card";
import EngineerList from '../engineer-list/engineer-list';
import HeaderBar from "../header-bar/header-bar";
import { HeaderBarContainer } from "../header-bar/header-bar-container";

export default class SummaryCard extends Component {
    constructor()
    {
        super();
        this.state = {
            isEngineerListOpen: false,
            engineerName: ""
        };
    }

    showEngineerList = () => {
        this.toggleEngineerList(true);
    };

    closeEngineerList = () => {
        this.toggleEngineerList(false);
    }

    toggleEngineerList = (isOpen) => {
        this.setState({ isEngineerListOpen: isOpen });
    }

    onEngineersLoaded = (engineers) => {
        this.setEngineerName(engineers.filter(x => x.id === this.props.engineerId)[0])
    }

    setEngineerName = (engineer) => {

        if (!engineer) {
            return;
        }

        this.setState({engineerName: engineer.fullName });
    };

    selectEngineer = (engineer) => {
        this.toggleEngineerList(false);
        this.setEngineerName(engineer);
        this.props.onSelectEngineer(engineer);
    }

    changeDay = (selectedDate) => {
        this.props.onChangeDay(selectedDate);
    }

    render() {
        return (<div>
            <EngineerList
                isOpen={this.state.isEngineerListOpen}
                onCancel={this.closeEngineerList}
                onSelect={this.selectEngineer}
                onEngineersLoaded={this.onEngineersLoaded} />
            <HeaderBarContainer>
                <HeaderBar 
                    user={this.props.engineer}
                    currentDate={this.props.currentDate}
                    onChangeDay={this.changeDay}
                />
                <Grid
                    container
                    direction="row"
                    justify="space-between">
                    <Grid item xs="auto">
                        <Chip
                            color="default"
                            variant="outlined"
                            label={"Projected: £" + this.props.projectedRevenue}></Chip>
                    </Grid>
                    <Grid item xs="auto">
                        <Button color="inherit" onClick={this.showEngineerList}>
                            {this.state.engineerName}
                            <KeyboardArrowDown />
                        </Button>
                    </Grid>
                    <Grid item xs="auto">
                        <StatusCard
                            caption={"Realised: £" + this.props.realisedRevenue}
                            value={this.props.realisedRevenue} />
                    </Grid>
                </Grid>
            </HeaderBarContainer>
        </div>
        );
    }
}